/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Typography } from "@mui/material";
import Button from "components/Buttons/ThemeButton";
import styled, { CSSProperties } from "styled-components";

export const Container = styled.div`
	width: 100%;
	height: 100%;
	padding: 0px;
	position: relative;
	display: flex;
	justify-content: center;
	overflow: hidden;
	border-radius: 18px;
	//font-size: clamp(1px, 4dvw, 22px);
	font-size: 24px;

	@media (orientation: landscape) {
		font-size: 22px;
		//font-size: clamp(1px, 1.6dvw, 22px);
		justify-content: right;
	}
`;

export const OfferItem = styled.div`
	position: relative;
	grid-template-rows: auto;
	background-color: rgba(0, 0, 0, 0.25);
	border-radius: 16px;
	padding: 0.5em 0.5em;
	gap: 0.5rem;
	box-sizing: border-box;
	height: auto;
	z-index: 999;
	align-content: stretch;
	width: 100%;
`;

export const LoyaltyContainer = styled.div`
	position: relative;
	background-color: rgba(0, 0, 0, 0.25);
	border-radius: 16px;
	//padding: 0.5em 0.5em;
	gap: 0.5rem;

	box-sizing: border-box;
	width: 100%;
	height: auto;
	min-height: 3.6em;
	z-index: 999;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const DataContainer = styled.div`
	position: absolute;
	width: 93%;
	bottom: 3%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	@media (orientation: landscape) {
		bottom: 12%;
		right: 4%;
		width: 45%;
		justify-content: right;
		align-items: right;
	}
`;

export const Items = styled.div`
	justify-content: center;
	align-items: end;
	display: flex;
	flex-wrap: nowrap;
`;

export const RewardItem = styled.div<any>`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	flex-basis: ${(props) => props.width};
	box-sizing: border-box;
`;

export const RewardAmountContainer = styled.div``;

export const ItemImage = styled.img`
	object-fit: contain;
	justify-self: center;
	align-self: center;

	width: 100%;
	height: 3.2em;

	&.crown {
		width: 2.5em;
		height: 2.5em;
	}
`;

export const Text = styled.div`
	//text-shadow: 0px 0.14em #000;
	-webkit-text-stroke-width: 0.22em;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;
	color: #fff;
	font-weight: 400;
	font-family: Baloo;
`;

export const RewardAmount = styled(Text)`
	font-size: 0.9em;
`;

export const SubTitle = styled(Text)`
	width: 100%;
	margin-left: 1.5em;
	font-size: 0.9em;
	line-height: 2.1em;

	@media (orientation: landscape) {
		display: flex;
		align-items: end;
		height: 2em;
		line-height: 1.5em;
	}
`;

export const InfoContainer = styled(Text)`
	font-size: 0.9em;
	line-height: 1.1em;
	display: flex;
	align-items: left;
	flex-direction: column;
	justify-content: center;
`;

export const LoyaltyPoints = styled(Text)`
	font-size: 1em;
`;

export const CrossOutValue = styled(Text)`
	font-size: 0.92em;
	font-weight: 500;
	color: #eb5757;
	position: relative;
	width: fit-content;
	margin-left: 0.2em;

	&::after {
		content: "";
		position: absolute;
		width: calc(100% + 0.3em);
		left: -0.2em;
		top: 46%;
		transform: translateY(-50%);
		height: 0.08em;
		background: #eb5757;
		border: 0.085em solid #000;
		border-radius: 12px;
		pointer-events: none;
	}
`;

export const PoisBounty = styled(Text)`
	font-size: 0.8em;
	color: #fbbd05;
	font-weight: 700;
`;

export const CustomButtom = styled(Button)`
	width: 100%;
	margin-top: 1.2em;
	height: 3.1em;
	font-size: 1em;

	@media (orientation: landscape) {
		width: 75%;
	}
`;

export const InfoButton = styled.img`
	position: absolute;
	top: 10%;
	right: 2%;
	z-index: 2;
	width: 1.5em;
	height: 1.5em;
	cursor: pointer;
`;

export const bannerStyle: CSSProperties = {
	height: "2.2em",
	display: "flex",
	alignItems: "center"
};

export const textStyle: CSSProperties = {
	lineHeight: "2.2em",
	fontSize: "0.9em"
};
